import { useRouter } from "src/helpers"; // import lodash from 'lodash';
// import deepdash from 'deepdash-es';

import {
    withHookForQuestion,
    withUpdateQuestion,
} from "src/modules/question/operations";
import { compose } from "src/helpers";

import EditView from "./component";

const Edit = (props) => {
    const { updateQuestion } = props;
    const router = useRouter();

    const onFinish = async (values: any) => {
        await updateQuestion(values);
        router.push("/question");
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return (
        <EditView
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            {...props}
        />
    );
};

export default compose(withHookForQuestion, withUpdateQuestion)(Edit);
